import { fetchListVerificacion } from "../http-common";
import { IPlantillaVerificacionPersonaRequest, IPostCrearPlantillaVerificacion } from "../../Interfaces/IPlantillaVerificacion";

const PostCrearPlantillaVerificacion = (request: IPostCrearPlantillaVerificacion) => {
  return fetchListVerificacion.post(
    "PlantillaVerficacion/CrearPlantillaVerificacion",
    request
  );
};
const GetPlantillaVerificacionByPersona=(request:IPlantillaVerificacionPersonaRequest)=>{
  return fetchListVerificacion.get(
    "PlantillaVerficacion/ListarPlantillaByPersona",{params: request,}
  );
}

const PlantillaVerificacionService = {
    PostCrearPlantillaVerificacion,GetPlantillaVerificacionByPersona
};

export default PlantillaVerificacionService;
